"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var HttpResponse =
/** @class */
function () {
  function HttpResponse(raw) {
    var _a, _b, _c, _d, _e;

    this.raw = raw;
    this.statusCode = (_b = (_a = raw.data) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.code;
    this.success = (raw.status === 200 || raw.status === 201) && this.statusCode === 1000;
    this.data = (_c = raw.data) === null || _c === void 0 ? void 0 : _c.data;
    this.duplicate = this.statusCode === 1799;
    this.translationKey = (_e = (_d = raw.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.translationKey;
  }

  return HttpResponse;
}();

exports.HttpResponse = HttpResponse;